import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AddInventoryPackageResult = {
  __typename?: 'AddInventoryPackageResult';
  Error?: Maybe<Scalars['String']>;
  Item?: Maybe<GetInventoryItem>;
  PackageCount?: Maybe<Scalars['Int']>;
};

export type AddReleasedPackageResult = {
  __typename?: 'AddReleasedPackageResult';
  Error?: Maybe<Scalars['String']>;
  Item?: Maybe<GetReceiptItem>;
};

export type AddedInventoryPackage = {
  InventoryId: Scalars['Int'];
  PackageNumber: Scalars['String'];
};

export type AddedReleasePackage = {
  PackageNumber: Scalars['String'];
  ReceiptId: Scalars['Int'];
};

export type Address = {
  __typename?: 'Address';
  CountryCode2: Scalars['String'];
  Postcode?: Maybe<Scalars['String']>;
  Settlement: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  StreetNumber?: Maybe<Scalars['String']>;
};

export type AssistantMessageHistoryInput = {
  Content: Scalars['String'];
  Role: Scalars['String'];
  Timestamp?: InputMaybe<Scalars['String']>;
};

export type AssistantSpeechTokenResult = {
  __typename?: 'AssistantSpeechTokenResult';
  Endpoint: Scalars['String'];
  ExpiresInSeconds: Scalars['Int'];
  Region: Scalars['String'];
  Token: Scalars['String'];
};

export type Attachment = {
  __typename?: 'Attachment';
  InvoiceAttachmentId?: Maybe<Scalars['Int']>;
  Name: Scalars['String'];
  OrderAttachmentId?: Maybe<Scalars['Int']>;
  Type?: Maybe<Scalars['String']>;
  Url: Scalars['String'];
};

export type Cargo = {
  __typename?: 'Cargo';
  IsChild: Scalars['Boolean'];
  Name: Scalars['String'];
  Quantity: Scalars['Int'];
  QuantityUnit: Scalars['String'];
  Volume?: Maybe<Scalars['Float']>;
  Weight?: Maybe<Scalars['Int']>;
};

export type CreateAssistantThreadResult = {
  __typename?: 'CreateAssistantThreadResult';
  ThreadId: Scalars['String'];
  WebPubSubUrl: Scalars['String'];
};

export type DangerousGoodsItem = {
  __typename?: 'DangerousGoodsItem';
  ADRMarkingCode1?: Maybe<Scalars['String']>;
  ADRMarkingCode2?: Maybe<Scalars['String']>;
  ADRMarkingCode3?: Maybe<Scalars['String']>;
  Amount?: Maybe<Scalars['Float']>;
  AmountTypeName?: Maybe<Scalars['String']>;
  DangerousGoodsTypeName?: Maybe<Scalars['String']>;
  EnvironmentallyHazardous: Scalars['Boolean'];
  Name?: Maybe<Scalars['String']>;
  OrderItemDangerousGoodsId: Scalars['Int'];
  PackageTypeName?: Maybe<Scalars['String']>;
  Points?: Maybe<Scalars['Int']>;
  Quantity?: Maybe<Scalars['Int']>;
  ReceiptPackageId: Scalars['Int'];
  UNNumber?: Maybe<Scalars['String']>;
};

export type DeviationType = {
  __typename?: 'DeviationType';
  DeviationTypeId: Scalars['Int'];
  Name: Scalars['String'];
  Photo: Scalars['Boolean'];
};

export type GetInventoryItem = {
  __typename?: 'GetInventoryItem';
  CheckedAt: Scalars['String'];
  FactHeight?: Maybe<Scalars['Float']>;
  FactLength?: Maybe<Scalars['Float']>;
  FactWeight?: Maybe<Scalars['Int']>;
  FactWidth?: Maybe<Scalars['Float']>;
  IndicatedHeight?: Maybe<Scalars['Float']>;
  IndicatedLength?: Maybe<Scalars['Float']>;
  IndicatedWeight?: Maybe<Scalars['Int']>;
  IndicatedWidth?: Maybe<Scalars['Float']>;
  InventoryPackageId: Scalars['Int'];
  PackageName: Scalars['String'];
  PackageNumber: Scalars['String'];
  Quantity: Scalars['Int'];
  StorageArea?: Maybe<Scalars['String']>;
  UnitName: Scalars['String'];
  UserName: Scalars['String'];
};

export type GetInventoryResult = {
  __typename?: 'GetInventoryResult';
  Inventory: ListInventoryItem;
  Items: Array<GetInventoryItem>;
  PackageCount: Scalars['Int'];
};

export type GetReceiptItem = {
  __typename?: 'GetReceiptItem';
  DestinationPartner: Partner;
  Deviations: Array<Scalars['Int']>;
  Execute: Scalars['Boolean'];
  ExecutedAt?: Maybe<Scalars['String']>;
  FactHeight?: Maybe<Scalars['Float']>;
  FactLength?: Maybe<Scalars['Float']>;
  FactPalletSpaces?: Maybe<Scalars['Int']>;
  FactQuantity?: Maybe<Scalars['Int']>;
  FactQuantityUnit?: Maybe<Unit>;
  FactWeight?: Maybe<Scalars['Int']>;
  FactWidth?: Maybe<Scalars['Float']>;
  IndicatedHeight?: Maybe<Scalars['Float']>;
  IndicatedLength?: Maybe<Scalars['Float']>;
  IndicatedPalletSpaces?: Maybe<Scalars['Int']>;
  IndicatedWeight?: Maybe<Scalars['Int']>;
  IndicatedWidth?: Maybe<Scalars['Float']>;
  OrderNumber: Scalars['String'];
  PackageName: Scalars['String'];
  PackageNumber: Scalars['String'];
  Photos: Array<Scalars['String']>;
  PickedAt?: Maybe<Scalars['String']>;
  Quantity: Scalars['Int'];
  QuantityUnit: Unit;
  ReceiptActivityId: Scalars['Int'];
  ReceiptPackageId: Scalars['Int'];
  SecondaryPackageNumber?: Maybe<Scalars['String']>;
  SingleLabel: Scalars['Boolean'];
  StorageArea?: Maybe<Scalars['String']>;
};

export type GetReceiptResult = {
  __typename?: 'GetReceiptResult';
  DangerousGoods?: Maybe<Array<Maybe<DangerousGoodsItem>>>;
  DangerousGoodsFeature: Scalars['Boolean'];
  DeviationTypes: Array<DeviationType>;
  Items: Array<GetReceiptItem>;
  Receipt: ListReceiptItem;
  Units: Array<Unit>;
};

export type InventoryState = {
  __typename?: 'InventoryState';
  InventoryStateId: Scalars['Int'];
  Name: Scalars['String'];
};

export enum InvitationCheckResult {
  EnterPin = 'EnterPIN',
  Invalid = 'Invalid',
  Validated = 'Validated'
}

export type ListInventoriesResult = {
  __typename?: 'ListInventoriesResult';
  Items: Array<ListInventoryItem>;
};

export type ListInventoryItem = {
  __typename?: 'ListInventoryItem';
  BeginAt: Scalars['String'];
  EndAt?: Maybe<Scalars['String']>;
  InventoryId: Scalars['Int'];
  InventoryState: InventoryState;
};

export type ListMessageItem = {
  __typename?: 'ListMessageItem';
  IsMyMessage: Scalars['Boolean'];
  IsNotified: Scalars['Boolean'];
  MessageId: Scalars['Int'];
  ReadAt?: Maybe<Scalars['String']>;
  SenderName: Scalars['String'];
  SentAt: Scalars['String'];
  Subject: Scalars['String'];
};

export type ListMessagesResult = {
  __typename?: 'ListMessagesResult';
  Items: Array<ListMessageItem>;
};

export type ListOrderItem = {
  __typename?: 'ListOrderItem';
  Cargos: Array<Cargo>;
  Events: Array<OrderEvent>;
  ExternalNumbers: Array<OrderExternalNumber>;
  IsCompleted: Scalars['Boolean'];
  IsDelivered: Scalars['Boolean'];
  IsInProgress: Scalars['Boolean'];
  IsInvoiced: Scalars['Boolean'];
  IsInvoicing: Scalars['Boolean'];
  IsPaid: Scalars['Boolean'];
  IsPaying: Scalars['Boolean'];
  IsShipping: Scalars['Boolean'];
  Locations: Array<OrderLocation>;
  MessageCount: Scalars['Int'];
  OrderId: Scalars['Int'];
  OrderNumber: Scalars['String'];
  PDFs: Array<Attachment>;
  PaymentDue: Scalars['Boolean'];
  UnreadMessageCount: Scalars['Int'];
};

export type ListOrdersResult = {
  __typename?: 'ListOrdersResult';
  InvitationCode?: Maybe<Scalars['String']>;
  IsUser?: Maybe<Scalars['Boolean']>;
  Orders: Array<ListOrderItem>;
  UpdatedToken?: Maybe<Scalars['String']>;
};

export type ListReceiptItem = {
  __typename?: 'ListReceiptItem';
  AdHocItems?: Maybe<Scalars['Boolean']>;
  Date?: Maybe<Scalars['String']>;
  PackageCount?: Maybe<Scalars['Int']>;
  Partner?: Maybe<Partner>;
  PickedAt?: Maybe<Scalars['String']>;
  Picking?: Maybe<Scalars['Boolean']>;
  Ramp?: Maybe<Ramp>;
  ReceiptId: Scalars['Int'];
  ReceiptState?: Maybe<ReceiptState>;
  ReceiptType?: Maybe<ReceiptType>;
  TrailerPlateNumber?: Maybe<Scalars['String']>;
  TruckPlateNumber?: Maybe<Scalars['String']>;
};

export type ListReceiptsResult = {
  __typename?: 'ListReceiptsResult';
  Items: Array<ListReceiptItem>;
};

export type LoginResult = {
  __typename?: 'LoginResult';
  success: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
  userDisplayName?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  AddInventoryPackage: AddInventoryPackageResult;
  AddReleasedPackage: AddReleasedPackageResult;
  CreateAssistantThread: CreateAssistantThreadResult;
  GetAssistantSpeechToken: AssistantSpeechTokenResult;
  GetNFCKey: Scalars['String'];
  GetVAPIDPublicKey: Scalars['String'];
  GetWebPubSubClientAccessUrl: Scalars['String'];
  InventoryExecuted: Scalars['Boolean'];
  PackagePicked: PackagePickedResult;
  PackageReceived: PackageReceivedResult;
  PackageReleased: PackageReleasedResult;
  PrintLabel: Scalars['Boolean'];
  PrintLabels: Scalars['Boolean'];
  ReceiptExecuted: Scalars['Boolean'];
  ReceiptPicked: Scalars['Boolean'];
  RefreshReleaseReceipt: Scalars['Boolean'];
  RegisterPushSubscription: Scalars['Boolean'];
  SaveAssistantOrder: SaveAssistantOrderResult;
  SaveNFCKey: Scalars['Boolean'];
  SendAssistantMessage: SendAssistantMessageResult;
  SendNewMessage: Scalars['Boolean'];
  SetMessagesAsRead: Scalars['Boolean'];
  ValidateInvitationPIN: ValidateInvitationPinResult;
  ValidateNFCKey: ValidateNfcKeyResult;
  login: LoginResult;
  logout: Scalars['Boolean'];
  saveToken: Scalars['Boolean'];
};


export type MutationAddInventoryPackageArgs = {
  AddedInventoryPackage: AddedInventoryPackage;
};


export type MutationAddReleasedPackageArgs = {
  AddedReleasePackage: AddedReleasePackage;
};


export type MutationInventoryExecutedArgs = {
  InventoryId: Scalars['Int'];
};


export type MutationPackagePickedArgs = {
  PickedPackage: PickedPackage;
};


export type MutationPackageReceivedArgs = {
  ReceivedPackage: ReceivedPackage;
};


export type MutationPackageReleasedArgs = {
  ReleasedPackage: ReleasedPackage;
};


export type MutationPrintLabelArgs = {
  ReceiptActivityId: Scalars['Int'];
  ReceiptId: Scalars['Int'];
};


export type MutationPrintLabelsArgs = {
  ReceiptId: Scalars['Int'];
};


export type MutationReceiptExecutedArgs = {
  ReceiptId: Scalars['Int'];
};


export type MutationReceiptPickedArgs = {
  ReceiptId: Scalars['Int'];
};


export type MutationRefreshReleaseReceiptArgs = {
  ReceiptId: Scalars['Int'];
};


export type MutationRegisterPushSubscriptionArgs = {
  Subscription: PushSubscriptionInput;
};


export type MutationSaveAssistantOrderArgs = {
  input: SaveAssistantOrderInput;
};


export type MutationSaveNfcKeyArgs = {
  NFCKey: Scalars['String'];
};


export type MutationSendAssistantMessageArgs = {
  input: SendAssistantMessageInput;
};


export type MutationSendNewMessageArgs = {
  Message: Scalars['String'];
  OrderId: Scalars['Int'];
};


export type MutationSetMessagesAsReadArgs = {
  OrderId: Scalars['Int'];
};


export type MutationValidateInvitationPinArgs = {
  InvitationCode: Scalars['String'];
  PINCode: Scalars['String'];
};


export type MutationValidateNfcKeyArgs = {
  NFCKey: Scalars['String'];
};


export type MutationLoginArgs = {
  name: Scalars['String'];
  password: Scalars['String'];
};


export type MutationSaveTokenArgs = {
  token: Scalars['String'];
};

export type OrderEvent = {
  __typename?: 'OrderEvent';
  EventTime: Scalars['String'];
  Location?: Maybe<Scalars['String']>;
  OrderEventId: Scalars['Int'];
  Type: Scalars['String'];
};

export type OrderExternalNumber = {
  __typename?: 'OrderExternalNumber';
  ExternalNumber: Scalars['String'];
};

export type OrderLocation = {
  __typename?: 'OrderLocation';
  Address: Address;
  LoadingCompleted: Scalars['Boolean'];
  LoadingDate?: Maybe<Scalars['String']>;
  Partner?: Maybe<Partner>;
  UnloadingCompleted: Scalars['Boolean'];
  UnloadingDate?: Maybe<Scalars['String']>;
};

export type PackagePickedResult = {
  __typename?: 'PackagePickedResult';
  PickedAt?: Maybe<Scalars['String']>;
};

export type PackageReceivedResult = {
  __typename?: 'PackageReceivedResult';
  ExecutedAt?: Maybe<Scalars['String']>;
  Photos: Array<Scalars['String']>;
};

export type PackageReleasedResult = {
  __typename?: 'PackageReleasedResult';
  ExecutedAt?: Maybe<Scalars['String']>;
};

export type Partner = {
  __typename?: 'Partner';
  Name?: Maybe<Scalars['String']>;
  PartnerId?: Maybe<Scalars['Int']>;
};

export enum PartnerPortalSearchMode {
  Address = 'Address',
  Identifier = 'Identifier',
  Name = 'Name'
}

export type PdfFileInput = {
  Name: Scalars['String'];
  Path: Scalars['String'];
};

export type PickedPackage = {
  ReceiptPackageId: Scalars['Int'];
};

export type PushSubscriptionInput = {
  endpoint: Scalars['String'];
  keys: PushSubscriptionKeysInput;
};

export type PushSubscriptionKeysInput = {
  auth: Scalars['String'];
  p256dh: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  CheckInvitation: InvitationCheckResult;
  CheckPermission: Scalars['Boolean'];
  GetInventory: GetInventoryResult;
  GetReceipt: GetReceiptResult;
  ListInventories: ListInventoriesResult;
  ListMessages: ListMessagesResult;
  ListOrders: ListOrdersResult;
  ListReceipts: ListReceiptsResult;
  isLoggedIn: Scalars['Boolean'];
};


export type QueryCheckInvitationArgs = {
  InvitationCode: Scalars['String'];
};


export type QueryCheckPermissionArgs = {
  PermissionKey: Scalars['String'];
};


export type QueryGetInventoryArgs = {
  InventoryId: Scalars['Int'];
  MaxItemCount: Scalars['Int'];
};


export type QueryGetReceiptArgs = {
  ReceiptId: Scalars['Int'];
};


export type QueryListInventoriesArgs = {
  InventoryStateId?: InputMaybe<Scalars['Int']>;
};


export type QueryListMessagesArgs = {
  OrderId: Scalars['Int'];
  Skip?: InputMaybe<Scalars['Int']>;
};


export type QueryListOrdersArgs = {
  Search?: InputMaybe<Scalars['String']>;
  SearchMode?: InputMaybe<PartnerPortalSearchMode>;
  Skip?: InputMaybe<Scalars['Int']>;
};


export type QueryListReceiptsArgs = {
  ReceiptStateId?: InputMaybe<Scalars['Int']>;
  ReceiptTypeId?: InputMaybe<Scalars['Int']>;
};

export type Ramp = {
  __typename?: 'Ramp';
  Name?: Maybe<Scalars['String']>;
  RampId?: Maybe<Scalars['Int']>;
};

export type ReceiptState = {
  __typename?: 'ReceiptState';
  Name?: Maybe<Scalars['String']>;
  ReceiptStateId?: Maybe<Scalars['Int']>;
};

export type ReceiptType = {
  __typename?: 'ReceiptType';
  Name?: Maybe<Scalars['String']>;
  ReceiptTypeId?: Maybe<Scalars['Int']>;
};

export type ReceivedPackage = {
  Deviations: Array<Scalars['Int']>;
  FactHeight?: InputMaybe<Scalars['Float']>;
  FactLength?: InputMaybe<Scalars['Float']>;
  FactPalletSpaces?: InputMaybe<Scalars['Int']>;
  FactQuantity?: InputMaybe<Scalars['Int']>;
  FactQuantityUnitId?: InputMaybe<Scalars['Int']>;
  FactWeight?: InputMaybe<Scalars['Int']>;
  FactWidth?: InputMaybe<Scalars['Float']>;
  Photos: Array<Scalars['String']>;
  ReceiptPackageId: Scalars['Int'];
};

export type ReleasedPackage = {
  ReceiptPackageId: Scalars['Int'];
};

export type SaveAssistantOrderInput = {
  ChatMessages?: InputMaybe<Array<AssistantMessageHistoryInput>>;
  Language?: InputMaybe<Scalars['String']>;
  OrderJson: Scalars['String'];
  PdfFiles?: InputMaybe<Array<PdfFileInput>>;
};

export type SaveAssistantOrderResult = {
  __typename?: 'SaveAssistantOrderResult';
  Success: Scalars['Boolean'];
};

export type SendAssistantMessageInput = {
  CurrentMissingFields?: InputMaybe<Array<Scalars['String']>>;
  CurrentOrderJson?: InputMaybe<Scalars['String']>;
  FileIds?: InputMaybe<Array<Scalars['String']>>;
  Message: Scalars['String'];
  MessageHistory?: InputMaybe<Array<AssistantMessageHistoryInput>>;
  PdfContentBase64?: InputMaybe<Scalars['String']>;
  PdfFileName?: InputMaybe<Scalars['String']>;
  PreferredLanguage?: InputMaybe<Scalars['String']>;
  ThreadId: Scalars['String'];
};

export type SendAssistantMessageResult = {
  __typename?: 'SendAssistantMessageResult';
  AssistantResponse: Scalars['String'];
  Confidence?: Maybe<Scalars['Float']>;
  ExtractedData?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
  UploadedFileHostPath?: Maybe<Scalars['String']>;
  UploadedFilePath?: Maybe<Scalars['String']>;
};

export type Unit = {
  __typename?: 'Unit';
  Name: Scalars['String'];
  UnitId: Scalars['Int'];
};

export type ValidateInvitationPinResult = {
  __typename?: 'ValidateInvitationPINResult';
  success: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
};

export type ValidateNfcKeyResult = {
  __typename?: 'ValidateNFCKeyResult';
  success: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
  userDisplayName?: Maybe<Scalars['String']>;
};

export type LoginMutationVariables = Exact<{
  name: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginResult', success: boolean, token?: string | null, userDisplayName?: string | null } };

export type SaveTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type SaveTokenMutation = { __typename?: 'Mutation', saveToken: boolean };

export type IsLoggedInQueryVariables = Exact<{ [key: string]: never; }>;


export type IsLoggedInQuery = { __typename?: 'Query', isLoggedIn: boolean };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type GetVapidPublicKeyMutationVariables = Exact<{ [key: string]: never; }>;


export type GetVapidPublicKeyMutation = { __typename?: 'Mutation', GetVAPIDPublicKey: string };

export type RegisterPushSubscriptionMutationVariables = Exact<{
  Subscription: PushSubscriptionInput;
}>;


export type RegisterPushSubscriptionMutation = { __typename?: 'Mutation', RegisterPushSubscription: boolean };

export type CheckPermissionQueryVariables = Exact<{
  PermissionKey: Scalars['String'];
}>;


export type CheckPermissionQuery = { __typename?: 'Query', CheckPermission: boolean };

export type ValidateNfcKeyMutationVariables = Exact<{
  NFCKey: Scalars['String'];
}>;


export type ValidateNfcKeyMutation = { __typename?: 'Mutation', ValidateNFCKey: { __typename?: 'ValidateNFCKeyResult', success: boolean, token?: string | null, userDisplayName?: string | null } };

export type CreateAssistantThreadMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateAssistantThreadMutation = { __typename?: 'Mutation', CreateAssistantThread: { __typename?: 'CreateAssistantThreadResult', ThreadId: string, WebPubSubUrl: string } };

export type GetAssistantSpeechTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GetAssistantSpeechTokenMutation = { __typename?: 'Mutation', GetAssistantSpeechToken: { __typename?: 'AssistantSpeechTokenResult', Token: string, Region: string, Endpoint: string, ExpiresInSeconds: number } };

export type SendAssistantMessageMutationVariables = Exact<{
  input: SendAssistantMessageInput;
}>;


export type SendAssistantMessageMutation = { __typename?: 'Mutation', SendAssistantMessage: { __typename?: 'SendAssistantMessageResult', Success: boolean, UploadedFileHostPath?: string | null, UploadedFilePath?: string | null } };

export type SaveAssistantOrderMutationVariables = Exact<{
  input: SaveAssistantOrderInput;
}>;


export type SaveAssistantOrderMutation = { __typename?: 'Mutation', SaveAssistantOrder: { __typename?: 'SaveAssistantOrderResult', Success: boolean } };

export type ListOrdersQueryVariables = Exact<{
  Skip?: InputMaybe<Scalars['Int']>;
  Search?: InputMaybe<Scalars['String']>;
  SearchMode?: InputMaybe<PartnerPortalSearchMode>;
}>;


export type ListOrdersQuery = { __typename?: 'Query', ListOrders: { __typename?: 'ListOrdersResult', UpdatedToken?: string | null, InvitationCode?: string | null, IsUser?: boolean | null, Orders: Array<{ __typename?: 'ListOrderItem', OrderId: number, OrderNumber: string, IsCompleted: boolean, IsDelivered: boolean, IsInvoiced: boolean, IsPaid: boolean, IsInProgress: boolean, IsShipping: boolean, IsInvoicing: boolean, IsPaying: boolean, PaymentDue: boolean, MessageCount: number, UnreadMessageCount: number, ExternalNumbers: Array<{ __typename?: 'OrderExternalNumber', ExternalNumber: string }>, Cargos: Array<{ __typename?: 'Cargo', IsChild: boolean, Name: string, Quantity: number, QuantityUnit: string, Weight?: number | null, Volume?: number | null }>, Locations: Array<{ __typename?: 'OrderLocation', UnloadingDate?: string | null, UnloadingCompleted: boolean, LoadingDate?: string | null, LoadingCompleted: boolean, Partner?: { __typename?: 'Partner', Name?: string | null } | null, Address: { __typename?: 'Address', CountryCode2: string, Postcode?: string | null, Settlement: string, Street?: string | null, StreetNumber?: string | null } }>, Events: Array<{ __typename?: 'OrderEvent', OrderEventId: number, EventTime: string, Type: string, Location?: string | null }>, PDFs: Array<{ __typename?: 'Attachment', OrderAttachmentId?: number | null, InvoiceAttachmentId?: number | null, Type?: string | null, Name: string, Url: string }> }> } };

export type CheckInvitationQueryVariables = Exact<{
  InvitationCode: Scalars['String'];
}>;


export type CheckInvitationQuery = { __typename?: 'Query', CheckInvitation: InvitationCheckResult };

export type ListMessagesQueryVariables = Exact<{
  OrderId: Scalars['Int'];
  Skip?: InputMaybe<Scalars['Int']>;
}>;


export type ListMessagesQuery = { __typename?: 'Query', ListMessages: { __typename?: 'ListMessagesResult', Items: Array<{ __typename?: 'ListMessageItem', MessageId: number, SenderName: string, Subject: string, SentAt: string, IsNotified: boolean, ReadAt?: string | null, IsMyMessage: boolean }> } };

export type ValidateInvitationPinMutationVariables = Exact<{
  InvitationCode: Scalars['String'];
  PINCode: Scalars['String'];
}>;


export type ValidateInvitationPinMutation = { __typename?: 'Mutation', ValidateInvitationPIN: { __typename?: 'ValidateInvitationPINResult', success: boolean, token?: string | null } };

export type SendNewMessageMutationVariables = Exact<{
  OrderId: Scalars['Int'];
  Message: Scalars['String'];
}>;


export type SendNewMessageMutation = { __typename?: 'Mutation', SendNewMessage: boolean };

export type SetMessagesAsReadMutationVariables = Exact<{
  OrderId: Scalars['Int'];
}>;


export type SetMessagesAsReadMutation = { __typename?: 'Mutation', SetMessagesAsRead: boolean };

export type ListInventoriesQueryVariables = Exact<{
  InventoryStateId?: InputMaybe<Scalars['Int']>;
}>;


export type ListInventoriesQuery = { __typename?: 'Query', ListInventories: { __typename?: 'ListInventoriesResult', Items: Array<{ __typename?: 'ListInventoryItem', InventoryId: number, BeginAt: string, EndAt?: string | null, InventoryState: { __typename?: 'InventoryState', InventoryStateId: number, Name: string } }> } };

export type GetInventoryQueryVariables = Exact<{
  InventoryId: Scalars['Int'];
  MaxItemCount: Scalars['Int'];
}>;


export type GetInventoryQuery = { __typename?: 'Query', GetInventory: { __typename?: 'GetInventoryResult', PackageCount: number, Inventory: { __typename?: 'ListInventoryItem', InventoryId: number, BeginAt: string, EndAt?: string | null, InventoryState: { __typename?: 'InventoryState', InventoryStateId: number, Name: string } }, Items: Array<{ __typename?: 'GetInventoryItem', InventoryPackageId: number, PackageName: string, Quantity: number, UnitName: string, IndicatedWeight?: number | null, IndicatedLength?: number | null, IndicatedWidth?: number | null, IndicatedHeight?: number | null, FactWeight?: number | null, FactLength?: number | null, FactWidth?: number | null, FactHeight?: number | null, PackageNumber: string, StorageArea?: string | null, CheckedAt: string, UserName: string }> } };

export type AddInventoryPackageMutationVariables = Exact<{
  AddedInventoryPackage: AddedInventoryPackage;
}>;


export type AddInventoryPackageMutation = { __typename?: 'Mutation', AddInventoryPackage: { __typename?: 'AddInventoryPackageResult', Error?: string | null, PackageCount?: number | null, Item?: { __typename?: 'GetInventoryItem', InventoryPackageId: number, PackageName: string, Quantity: number, UnitName: string, IndicatedWeight?: number | null, IndicatedLength?: number | null, IndicatedWidth?: number | null, IndicatedHeight?: number | null, FactWeight?: number | null, FactLength?: number | null, FactWidth?: number | null, FactHeight?: number | null, PackageNumber: string, StorageArea?: string | null, CheckedAt: string, UserName: string } | null } };

export type InventoryExecutedMutationVariables = Exact<{
  InventoryId: Scalars['Int'];
}>;


export type InventoryExecutedMutation = { __typename?: 'Mutation', InventoryExecuted: boolean };

export type GetNfcKeyMutationVariables = Exact<{ [key: string]: never; }>;


export type GetNfcKeyMutation = { __typename?: 'Mutation', GetNFCKey: string };

export type SaveNfcKeyMutationVariables = Exact<{
  NFCKey: Scalars['String'];
}>;


export type SaveNfcKeyMutation = { __typename?: 'Mutation', SaveNFCKey: boolean };

export type ListReceiptsQueryVariables = Exact<{
  ReceiptTypeId?: InputMaybe<Scalars['Int']>;
  ReceiptStateId?: InputMaybe<Scalars['Int']>;
}>;


export type ListReceiptsQuery = { __typename?: 'Query', ListReceipts: { __typename?: 'ListReceiptsResult', Items: Array<{ __typename?: 'ListReceiptItem', ReceiptId: number, Date?: string | null, PickedAt?: string | null, TruckPlateNumber?: string | null, TrailerPlateNumber?: string | null, PackageCount?: number | null, Picking?: boolean | null, AdHocItems?: boolean | null, ReceiptType?: { __typename?: 'ReceiptType', ReceiptTypeId?: number | null, Name?: string | null } | null, ReceiptState?: { __typename?: 'ReceiptState', ReceiptStateId?: number | null, Name?: string | null } | null, Partner?: { __typename?: 'Partner', PartnerId?: number | null, Name?: string | null } | null, Ramp?: { __typename?: 'Ramp', RampId?: number | null, Name?: string | null } | null }> } };

export type GetReceiptQueryVariables = Exact<{
  ReceiptId: Scalars['Int'];
}>;


export type GetReceiptQuery = { __typename?: 'Query', GetReceipt: { __typename?: 'GetReceiptResult', DangerousGoodsFeature: boolean, Receipt: { __typename?: 'ListReceiptItem', ReceiptId: number, Date?: string | null, TruckPlateNumber?: string | null, TrailerPlateNumber?: string | null, ReceiptType?: { __typename?: 'ReceiptType', ReceiptTypeId?: number | null, Name?: string | null } | null, ReceiptState?: { __typename?: 'ReceiptState', ReceiptStateId?: number | null, Name?: string | null } | null, Partner?: { __typename?: 'Partner', PartnerId?: number | null, Name?: string | null } | null, Ramp?: { __typename?: 'Ramp', RampId?: number | null, Name?: string | null } | null }, DeviationTypes: Array<{ __typename?: 'DeviationType', DeviationTypeId: number, Name: string, Photo: boolean }>, Units: Array<{ __typename?: 'Unit', UnitId: number, Name: string }>, Items: Array<{ __typename?: 'GetReceiptItem', Execute: boolean, SingleLabel: boolean, ReceiptPackageId: number, ReceiptActivityId: number, ExecutedAt?: string | null, OrderNumber: string, PackageName: string, Quantity: number, FactQuantity?: number | null, IndicatedPalletSpaces?: number | null, IndicatedWeight?: number | null, IndicatedLength?: number | null, IndicatedWidth?: number | null, IndicatedHeight?: number | null, FactPalletSpaces?: number | null, FactWeight?: number | null, FactLength?: number | null, FactWidth?: number | null, FactHeight?: number | null, PackageNumber: string, SecondaryPackageNumber?: string | null, StorageArea?: string | null, Deviations: Array<number>, Photos: Array<string>, QuantityUnit: { __typename?: 'Unit', UnitId: number, Name: string }, FactQuantityUnit?: { __typename?: 'Unit', UnitId: number, Name: string } | null, DestinationPartner: { __typename?: 'Partner', PartnerId?: number | null, Name?: string | null } }>, DangerousGoods?: Array<{ __typename?: 'DangerousGoodsItem', OrderItemDangerousGoodsId: number, DangerousGoodsTypeName?: string | null, UNNumber?: string | null, Name?: string | null, Amount?: number | null, AmountTypeName?: string | null, Quantity?: number | null, PackageTypeName?: string | null, Points?: number | null, EnvironmentallyHazardous: boolean, ADRMarkingCode1?: string | null, ADRMarkingCode2?: string | null, ADRMarkingCode3?: string | null, ReceiptPackageId: number } | null> | null } };

export type GetPickingReceiptQueryVariables = Exact<{
  ReceiptId: Scalars['Int'];
}>;


export type GetPickingReceiptQuery = { __typename?: 'Query', GetReceipt: { __typename?: 'GetReceiptResult', Receipt: { __typename?: 'ListReceiptItem', ReceiptId: number, Date?: string | null, TruckPlateNumber?: string | null, TrailerPlateNumber?: string | null, ReceiptType?: { __typename?: 'ReceiptType', ReceiptTypeId?: number | null, Name?: string | null } | null, ReceiptState?: { __typename?: 'ReceiptState', ReceiptStateId?: number | null, Name?: string | null } | null, Partner?: { __typename?: 'Partner', PartnerId?: number | null, Name?: string | null } | null, Ramp?: { __typename?: 'Ramp', RampId?: number | null, Name?: string | null } | null }, Items: Array<{ __typename?: 'GetReceiptItem', Execute: boolean, SingleLabel: boolean, ReceiptPackageId: number, ReceiptActivityId: number, PickedAt?: string | null, OrderNumber: string, PackageName: string, Quantity: number, FactQuantity?: number | null, IndicatedPalletSpaces?: number | null, IndicatedWeight?: number | null, IndicatedLength?: number | null, IndicatedWidth?: number | null, IndicatedHeight?: number | null, FactPalletSpaces?: number | null, FactWeight?: number | null, FactLength?: number | null, FactWidth?: number | null, FactHeight?: number | null, PackageNumber: string, SecondaryPackageNumber?: string | null, StorageArea?: string | null, Deviations: Array<number>, Photos: Array<string>, QuantityUnit: { __typename?: 'Unit', UnitId: number, Name: string }, FactQuantityUnit?: { __typename?: 'Unit', UnitId: number, Name: string } | null, DestinationPartner: { __typename?: 'Partner', PartnerId?: number | null, Name?: string | null } }> } };

export type GetReleaseReceiptQueryVariables = Exact<{
  ReceiptId: Scalars['Int'];
}>;


export type GetReleaseReceiptQuery = { __typename?: 'Query', GetReceipt: { __typename?: 'GetReceiptResult', Receipt: { __typename?: 'ListReceiptItem', ReceiptId: number, Date?: string | null, TruckPlateNumber?: string | null, TrailerPlateNumber?: string | null, AdHocItems?: boolean | null, ReceiptType?: { __typename?: 'ReceiptType', ReceiptTypeId?: number | null, Name?: string | null } | null, ReceiptState?: { __typename?: 'ReceiptState', ReceiptStateId?: number | null, Name?: string | null } | null, Partner?: { __typename?: 'Partner', PartnerId?: number | null, Name?: string | null } | null, Ramp?: { __typename?: 'Ramp', RampId?: number | null, Name?: string | null } | null }, Items: Array<{ __typename?: 'GetReceiptItem', Execute: boolean, SingleLabel: boolean, ReceiptPackageId: number, ReceiptActivityId: number, ExecutedAt?: string | null, OrderNumber: string, PackageName: string, Quantity: number, FactQuantity?: number | null, IndicatedWeight?: number | null, IndicatedLength?: number | null, IndicatedWidth?: number | null, IndicatedHeight?: number | null, FactWeight?: number | null, FactLength?: number | null, FactWidth?: number | null, FactHeight?: number | null, PackageNumber: string, SecondaryPackageNumber?: string | null, StorageArea?: string | null, Deviations: Array<number>, Photos: Array<string>, QuantityUnit: { __typename?: 'Unit', UnitId: number, Name: string }, FactQuantityUnit?: { __typename?: 'Unit', UnitId: number, Name: string } | null, DestinationPartner: { __typename?: 'Partner', PartnerId?: number | null, Name?: string | null } }> } };

export type PrintLabelsMutationVariables = Exact<{
  ReceiptId: Scalars['Int'];
}>;


export type PrintLabelsMutation = { __typename?: 'Mutation', PrintLabels: boolean };

export type PrintLabelMutationVariables = Exact<{
  ReceiptId: Scalars['Int'];
  ReceiptActivityId: Scalars['Int'];
}>;


export type PrintLabelMutation = { __typename?: 'Mutation', PrintLabel: boolean };

export type RefreshReleaseReceiptMutationVariables = Exact<{
  ReceiptId: Scalars['Int'];
}>;


export type RefreshReleaseReceiptMutation = { __typename?: 'Mutation', RefreshReleaseReceipt: boolean };

export type PackageReceivedMutationVariables = Exact<{
  ReceivedPackage: ReceivedPackage;
}>;


export type PackageReceivedMutation = { __typename?: 'Mutation', PackageReceived: { __typename?: 'PackageReceivedResult', ExecutedAt?: string | null, Photos: Array<string> } };

export type ReceiptExecutedMutationVariables = Exact<{
  ReceiptId: Scalars['Int'];
}>;


export type ReceiptExecutedMutation = { __typename?: 'Mutation', ReceiptExecuted: boolean };

export type PackagePickedMutationVariables = Exact<{
  PickedPackage: PickedPackage;
}>;


export type PackagePickedMutation = { __typename?: 'Mutation', PackagePicked: { __typename?: 'PackagePickedResult', PickedAt?: string | null } };

export type ReceiptPickedMutationVariables = Exact<{
  ReceiptId: Scalars['Int'];
}>;


export type ReceiptPickedMutation = { __typename?: 'Mutation', ReceiptPicked: boolean };

export type PackageReleasedMutationVariables = Exact<{
  ReleasedPackage: ReleasedPackage;
}>;


export type PackageReleasedMutation = { __typename?: 'Mutation', PackageReleased: { __typename?: 'PackageReleasedResult', ExecutedAt?: string | null } };

export type AddReleasedPackageMutationVariables = Exact<{
  AddedReleasePackage: AddedReleasePackage;
}>;


export type AddReleasedPackageMutation = { __typename?: 'Mutation', AddReleasedPackage: { __typename?: 'AddReleasedPackageResult', Error?: string | null, Item?: { __typename?: 'GetReceiptItem', Execute: boolean, SingleLabel: boolean, ReceiptPackageId: number, ReceiptActivityId: number, ExecutedAt?: string | null, OrderNumber: string, PackageName: string, Quantity: number, FactQuantity?: number | null, IndicatedWeight?: number | null, IndicatedLength?: number | null, IndicatedWidth?: number | null, IndicatedHeight?: number | null, FactWeight?: number | null, FactLength?: number | null, FactWidth?: number | null, FactHeight?: number | null, PackageNumber: string, SecondaryPackageNumber?: string | null, StorageArea?: string | null, Deviations: Array<number>, Photos: Array<string>, QuantityUnit: { __typename?: 'Unit', UnitId: number, Name: string }, FactQuantityUnit?: { __typename?: 'Unit', UnitId: number, Name: string } | null, DestinationPartner: { __typename?: 'Partner', PartnerId?: number | null, Name?: string | null } } | null } };

export type GetWebPubSubClientAccessUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type GetWebPubSubClientAccessUrlMutation = { __typename?: 'Mutation', GetWebPubSubClientAccessUrl: string };


export const LoginDocument = gql`
    mutation login($name: String!, $password: String!) {
  login(name: $name, password: $password) {
    success
    token
    userDisplayName
  }
}
    `;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      name: // value for 'name'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const SaveTokenDocument = gql`
    mutation saveToken($token: String!) {
  saveToken(token: $token) @client
}
    `;

/**
 * __useSaveTokenMutation__
 *
 * To run a mutation, you first call `useSaveTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTokenMutation, { data, loading, error }] = useSaveTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSaveTokenMutation(baseOptions?: Apollo.MutationHookOptions<SaveTokenMutation, SaveTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTokenMutation, SaveTokenMutationVariables>(SaveTokenDocument, options);
      }
export type SaveTokenMutationHookResult = ReturnType<typeof useSaveTokenMutation>;
export type SaveTokenMutationResult = Apollo.MutationResult<SaveTokenMutation>;
export type SaveTokenMutationOptions = Apollo.BaseMutationOptions<SaveTokenMutation, SaveTokenMutationVariables>;
export const IsLoggedInDocument = gql`
    query isLoggedIn {
  isLoggedIn @client
}
    `;

/**
 * __useIsLoggedInQuery__
 *
 * To run a query within a React component, call `useIsLoggedInQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsLoggedInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsLoggedInQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsLoggedInQuery(baseOptions?: Apollo.QueryHookOptions<IsLoggedInQuery, IsLoggedInQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsLoggedInQuery, IsLoggedInQueryVariables>(IsLoggedInDocument, options);
      }
export function useIsLoggedInLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsLoggedInQuery, IsLoggedInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsLoggedInQuery, IsLoggedInQueryVariables>(IsLoggedInDocument, options);
        }
export type IsLoggedInQueryHookResult = ReturnType<typeof useIsLoggedInQuery>;
export type IsLoggedInLazyQueryHookResult = ReturnType<typeof useIsLoggedInLazyQuery>;
export type IsLoggedInQueryResult = Apollo.QueryResult<IsLoggedInQuery, IsLoggedInQueryVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout @client
}
    `;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const GetVapidPublicKeyDocument = gql`
    mutation GetVAPIDPublicKey {
  GetVAPIDPublicKey
}
    `;

/**
 * __useGetVapidPublicKeyMutation__
 *
 * To run a mutation, you first call `useGetVapidPublicKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetVapidPublicKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getVapidPublicKeyMutation, { data, loading, error }] = useGetVapidPublicKeyMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetVapidPublicKeyMutation(baseOptions?: Apollo.MutationHookOptions<GetVapidPublicKeyMutation, GetVapidPublicKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetVapidPublicKeyMutation, GetVapidPublicKeyMutationVariables>(GetVapidPublicKeyDocument, options);
      }
export type GetVapidPublicKeyMutationHookResult = ReturnType<typeof useGetVapidPublicKeyMutation>;
export type GetVapidPublicKeyMutationResult = Apollo.MutationResult<GetVapidPublicKeyMutation>;
export type GetVapidPublicKeyMutationOptions = Apollo.BaseMutationOptions<GetVapidPublicKeyMutation, GetVapidPublicKeyMutationVariables>;
export const RegisterPushSubscriptionDocument = gql`
    mutation RegisterPushSubscription($Subscription: PushSubscriptionInput!) {
  RegisterPushSubscription(Subscription: $Subscription)
}
    `;

/**
 * __useRegisterPushSubscriptionMutation__
 *
 * To run a mutation, you first call `useRegisterPushSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterPushSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerPushSubscriptionMutation, { data, loading, error }] = useRegisterPushSubscriptionMutation({
 *   variables: {
 *      Subscription: // value for 'Subscription'
 *   },
 * });
 */
export function useRegisterPushSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<RegisterPushSubscriptionMutation, RegisterPushSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterPushSubscriptionMutation, RegisterPushSubscriptionMutationVariables>(RegisterPushSubscriptionDocument, options);
      }
export type RegisterPushSubscriptionMutationHookResult = ReturnType<typeof useRegisterPushSubscriptionMutation>;
export type RegisterPushSubscriptionMutationResult = Apollo.MutationResult<RegisterPushSubscriptionMutation>;
export type RegisterPushSubscriptionMutationOptions = Apollo.BaseMutationOptions<RegisterPushSubscriptionMutation, RegisterPushSubscriptionMutationVariables>;
export const CheckPermissionDocument = gql`
    query CheckPermission($PermissionKey: String!) {
  CheckPermission(PermissionKey: $PermissionKey)
}
    `;

/**
 * __useCheckPermissionQuery__
 *
 * To run a query within a React component, call `useCheckPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPermissionQuery({
 *   variables: {
 *      PermissionKey: // value for 'PermissionKey'
 *   },
 * });
 */
export function useCheckPermissionQuery(baseOptions: Apollo.QueryHookOptions<CheckPermissionQuery, CheckPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckPermissionQuery, CheckPermissionQueryVariables>(CheckPermissionDocument, options);
      }
export function useCheckPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckPermissionQuery, CheckPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckPermissionQuery, CheckPermissionQueryVariables>(CheckPermissionDocument, options);
        }
export type CheckPermissionQueryHookResult = ReturnType<typeof useCheckPermissionQuery>;
export type CheckPermissionLazyQueryHookResult = ReturnType<typeof useCheckPermissionLazyQuery>;
export type CheckPermissionQueryResult = Apollo.QueryResult<CheckPermissionQuery, CheckPermissionQueryVariables>;
export const ValidateNfcKeyDocument = gql`
    mutation ValidateNFCKey($NFCKey: String!) {
  ValidateNFCKey(NFCKey: $NFCKey) {
    success
    token
    userDisplayName
  }
}
    `;

/**
 * __useValidateNfcKeyMutation__
 *
 * To run a mutation, you first call `useValidateNfcKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateNfcKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateNfcKeyMutation, { data, loading, error }] = useValidateNfcKeyMutation({
 *   variables: {
 *      NFCKey: // value for 'NFCKey'
 *   },
 * });
 */
export function useValidateNfcKeyMutation(baseOptions?: Apollo.MutationHookOptions<ValidateNfcKeyMutation, ValidateNfcKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateNfcKeyMutation, ValidateNfcKeyMutationVariables>(ValidateNfcKeyDocument, options);
      }
export type ValidateNfcKeyMutationHookResult = ReturnType<typeof useValidateNfcKeyMutation>;
export type ValidateNfcKeyMutationResult = Apollo.MutationResult<ValidateNfcKeyMutation>;
export type ValidateNfcKeyMutationOptions = Apollo.BaseMutationOptions<ValidateNfcKeyMutation, ValidateNfcKeyMutationVariables>;
export const CreateAssistantThreadDocument = gql`
    mutation CreateAssistantThread {
  CreateAssistantThread {
    ThreadId
    WebPubSubUrl
  }
}
    `;

/**
 * __useCreateAssistantThreadMutation__
 *
 * To run a mutation, you first call `useCreateAssistantThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssistantThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssistantThreadMutation, { data, loading, error }] = useCreateAssistantThreadMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateAssistantThreadMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssistantThreadMutation, CreateAssistantThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssistantThreadMutation, CreateAssistantThreadMutationVariables>(CreateAssistantThreadDocument, options);
      }
export type CreateAssistantThreadMutationHookResult = ReturnType<typeof useCreateAssistantThreadMutation>;
export type CreateAssistantThreadMutationResult = Apollo.MutationResult<CreateAssistantThreadMutation>;
export type CreateAssistantThreadMutationOptions = Apollo.BaseMutationOptions<CreateAssistantThreadMutation, CreateAssistantThreadMutationVariables>;
export const GetAssistantSpeechTokenDocument = gql`
    mutation GetAssistantSpeechToken {
  GetAssistantSpeechToken {
    Token
    Region
    Endpoint
    ExpiresInSeconds
  }
}
    `;

/**
 * __useGetAssistantSpeechTokenMutation__
 *
 * To run a mutation, you first call `useGetAssistantSpeechTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAssistantSpeechTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAssistantSpeechTokenMutation, { data, loading, error }] = useGetAssistantSpeechTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetAssistantSpeechTokenMutation(baseOptions?: Apollo.MutationHookOptions<GetAssistantSpeechTokenMutation, GetAssistantSpeechTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetAssistantSpeechTokenMutation, GetAssistantSpeechTokenMutationVariables>(GetAssistantSpeechTokenDocument, options);
      }
export type GetAssistantSpeechTokenMutationHookResult = ReturnType<typeof useGetAssistantSpeechTokenMutation>;
export type GetAssistantSpeechTokenMutationResult = Apollo.MutationResult<GetAssistantSpeechTokenMutation>;
export type GetAssistantSpeechTokenMutationOptions = Apollo.BaseMutationOptions<GetAssistantSpeechTokenMutation, GetAssistantSpeechTokenMutationVariables>;
export const SendAssistantMessageDocument = gql`
    mutation SendAssistantMessage($input: SendAssistantMessageInput!) {
  SendAssistantMessage(input: $input) {
    Success
    UploadedFileHostPath
    UploadedFilePath
  }
}
    `;

/**
 * __useSendAssistantMessageMutation__
 *
 * To run a mutation, you first call `useSendAssistantMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAssistantMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAssistantMessageMutation, { data, loading, error }] = useSendAssistantMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendAssistantMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendAssistantMessageMutation, SendAssistantMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAssistantMessageMutation, SendAssistantMessageMutationVariables>(SendAssistantMessageDocument, options);
      }
export type SendAssistantMessageMutationHookResult = ReturnType<typeof useSendAssistantMessageMutation>;
export type SendAssistantMessageMutationResult = Apollo.MutationResult<SendAssistantMessageMutation>;
export type SendAssistantMessageMutationOptions = Apollo.BaseMutationOptions<SendAssistantMessageMutation, SendAssistantMessageMutationVariables>;
export const SaveAssistantOrderDocument = gql`
    mutation SaveAssistantOrder($input: SaveAssistantOrderInput!) {
  SaveAssistantOrder(input: $input) {
    Success
  }
}
    `;

/**
 * __useSaveAssistantOrderMutation__
 *
 * To run a mutation, you first call `useSaveAssistantOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAssistantOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAssistantOrderMutation, { data, loading, error }] = useSaveAssistantOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAssistantOrderMutation(baseOptions?: Apollo.MutationHookOptions<SaveAssistantOrderMutation, SaveAssistantOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAssistantOrderMutation, SaveAssistantOrderMutationVariables>(SaveAssistantOrderDocument, options);
      }
export type SaveAssistantOrderMutationHookResult = ReturnType<typeof useSaveAssistantOrderMutation>;
export type SaveAssistantOrderMutationResult = Apollo.MutationResult<SaveAssistantOrderMutation>;
export type SaveAssistantOrderMutationOptions = Apollo.BaseMutationOptions<SaveAssistantOrderMutation, SaveAssistantOrderMutationVariables>;
export const ListOrdersDocument = gql`
    query ListOrders($Skip: Int, $Search: String, $SearchMode: PartnerPortalSearchMode) {
  ListOrders(Skip: $Skip, Search: $Search, SearchMode: $SearchMode) {
    Orders {
      OrderId
      OrderNumber
      ExternalNumbers {
        ExternalNumber
      }
      IsCompleted
      IsDelivered
      IsInvoiced
      IsPaid
      IsInProgress
      IsShipping
      IsInvoicing
      IsPaying
      PaymentDue
      Cargos {
        IsChild
        Name
        Quantity
        QuantityUnit
        Weight
        Volume
      }
      Locations {
        UnloadingDate
        UnloadingCompleted
        LoadingDate
        LoadingCompleted
        Partner {
          Name
        }
        Address {
          CountryCode2
          Postcode
          Settlement
          Street
          StreetNumber
        }
      }
      Events {
        OrderEventId
        EventTime
        Type
        Location
      }
      PDFs {
        OrderAttachmentId
        InvoiceAttachmentId
        Type
        Name
        Url
      }
      MessageCount
      UnreadMessageCount
    }
    UpdatedToken
    InvitationCode
    IsUser
  }
}
    `;

/**
 * __useListOrdersQuery__
 *
 * To run a query within a React component, call `useListOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrdersQuery({
 *   variables: {
 *      Skip: // value for 'Skip'
 *      Search: // value for 'Search'
 *      SearchMode: // value for 'SearchMode'
 *   },
 * });
 */
export function useListOrdersQuery(baseOptions?: Apollo.QueryHookOptions<ListOrdersQuery, ListOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrdersQuery, ListOrdersQueryVariables>(ListOrdersDocument, options);
      }
export function useListOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrdersQuery, ListOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrdersQuery, ListOrdersQueryVariables>(ListOrdersDocument, options);
        }
export type ListOrdersQueryHookResult = ReturnType<typeof useListOrdersQuery>;
export type ListOrdersLazyQueryHookResult = ReturnType<typeof useListOrdersLazyQuery>;
export type ListOrdersQueryResult = Apollo.QueryResult<ListOrdersQuery, ListOrdersQueryVariables>;
export const CheckInvitationDocument = gql`
    query CheckInvitation($InvitationCode: String!) {
  CheckInvitation(InvitationCode: $InvitationCode)
}
    `;

/**
 * __useCheckInvitationQuery__
 *
 * To run a query within a React component, call `useCheckInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckInvitationQuery({
 *   variables: {
 *      InvitationCode: // value for 'InvitationCode'
 *   },
 * });
 */
export function useCheckInvitationQuery(baseOptions: Apollo.QueryHookOptions<CheckInvitationQuery, CheckInvitationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckInvitationQuery, CheckInvitationQueryVariables>(CheckInvitationDocument, options);
      }
export function useCheckInvitationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckInvitationQuery, CheckInvitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckInvitationQuery, CheckInvitationQueryVariables>(CheckInvitationDocument, options);
        }
export type CheckInvitationQueryHookResult = ReturnType<typeof useCheckInvitationQuery>;
export type CheckInvitationLazyQueryHookResult = ReturnType<typeof useCheckInvitationLazyQuery>;
export type CheckInvitationQueryResult = Apollo.QueryResult<CheckInvitationQuery, CheckInvitationQueryVariables>;
export const ListMessagesDocument = gql`
    query ListMessages($OrderId: Int!, $Skip: Int) {
  ListMessages(OrderId: $OrderId, Skip: $Skip) {
    Items {
      MessageId
      SenderName
      Subject
      SentAt
      IsNotified
      ReadAt
      IsMyMessage
    }
  }
}
    `;

/**
 * __useListMessagesQuery__
 *
 * To run a query within a React component, call `useListMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMessagesQuery({
 *   variables: {
 *      OrderId: // value for 'OrderId'
 *      Skip: // value for 'Skip'
 *   },
 * });
 */
export function useListMessagesQuery(baseOptions: Apollo.QueryHookOptions<ListMessagesQuery, ListMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMessagesQuery, ListMessagesQueryVariables>(ListMessagesDocument, options);
      }
export function useListMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMessagesQuery, ListMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMessagesQuery, ListMessagesQueryVariables>(ListMessagesDocument, options);
        }
export type ListMessagesQueryHookResult = ReturnType<typeof useListMessagesQuery>;
export type ListMessagesLazyQueryHookResult = ReturnType<typeof useListMessagesLazyQuery>;
export type ListMessagesQueryResult = Apollo.QueryResult<ListMessagesQuery, ListMessagesQueryVariables>;
export const ValidateInvitationPinDocument = gql`
    mutation ValidateInvitationPIN($InvitationCode: String!, $PINCode: String!) {
  ValidateInvitationPIN(InvitationCode: $InvitationCode, PINCode: $PINCode) {
    success
    token
  }
}
    `;

/**
 * __useValidateInvitationPinMutation__
 *
 * To run a mutation, you first call `useValidateInvitationPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateInvitationPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateInvitationPinMutation, { data, loading, error }] = useValidateInvitationPinMutation({
 *   variables: {
 *      InvitationCode: // value for 'InvitationCode'
 *      PINCode: // value for 'PINCode'
 *   },
 * });
 */
export function useValidateInvitationPinMutation(baseOptions?: Apollo.MutationHookOptions<ValidateInvitationPinMutation, ValidateInvitationPinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateInvitationPinMutation, ValidateInvitationPinMutationVariables>(ValidateInvitationPinDocument, options);
      }
export type ValidateInvitationPinMutationHookResult = ReturnType<typeof useValidateInvitationPinMutation>;
export type ValidateInvitationPinMutationResult = Apollo.MutationResult<ValidateInvitationPinMutation>;
export type ValidateInvitationPinMutationOptions = Apollo.BaseMutationOptions<ValidateInvitationPinMutation, ValidateInvitationPinMutationVariables>;
export const SendNewMessageDocument = gql`
    mutation SendNewMessage($OrderId: Int!, $Message: String!) {
  SendNewMessage(OrderId: $OrderId, Message: $Message)
}
    `;

/**
 * __useSendNewMessageMutation__
 *
 * To run a mutation, you first call `useSendNewMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNewMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNewMessageMutation, { data, loading, error }] = useSendNewMessageMutation({
 *   variables: {
 *      OrderId: // value for 'OrderId'
 *      Message: // value for 'Message'
 *   },
 * });
 */
export function useSendNewMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendNewMessageMutation, SendNewMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendNewMessageMutation, SendNewMessageMutationVariables>(SendNewMessageDocument, options);
      }
export type SendNewMessageMutationHookResult = ReturnType<typeof useSendNewMessageMutation>;
export type SendNewMessageMutationResult = Apollo.MutationResult<SendNewMessageMutation>;
export type SendNewMessageMutationOptions = Apollo.BaseMutationOptions<SendNewMessageMutation, SendNewMessageMutationVariables>;
export const SetMessagesAsReadDocument = gql`
    mutation SetMessagesAsRead($OrderId: Int!) {
  SetMessagesAsRead(OrderId: $OrderId)
}
    `;

/**
 * __useSetMessagesAsReadMutation__
 *
 * To run a mutation, you first call `useSetMessagesAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMessagesAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMessagesAsReadMutation, { data, loading, error }] = useSetMessagesAsReadMutation({
 *   variables: {
 *      OrderId: // value for 'OrderId'
 *   },
 * });
 */
export function useSetMessagesAsReadMutation(baseOptions?: Apollo.MutationHookOptions<SetMessagesAsReadMutation, SetMessagesAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMessagesAsReadMutation, SetMessagesAsReadMutationVariables>(SetMessagesAsReadDocument, options);
      }
export type SetMessagesAsReadMutationHookResult = ReturnType<typeof useSetMessagesAsReadMutation>;
export type SetMessagesAsReadMutationResult = Apollo.MutationResult<SetMessagesAsReadMutation>;
export type SetMessagesAsReadMutationOptions = Apollo.BaseMutationOptions<SetMessagesAsReadMutation, SetMessagesAsReadMutationVariables>;
export const ListInventoriesDocument = gql`
    query ListInventories($InventoryStateId: Int) {
  ListInventories(InventoryStateId: $InventoryStateId) {
    Items {
      InventoryId
      InventoryState {
        InventoryStateId
        Name
      }
      BeginAt
      EndAt
    }
  }
}
    `;

/**
 * __useListInventoriesQuery__
 *
 * To run a query within a React component, call `useListInventoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInventoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInventoriesQuery({
 *   variables: {
 *      InventoryStateId: // value for 'InventoryStateId'
 *   },
 * });
 */
export function useListInventoriesQuery(baseOptions?: Apollo.QueryHookOptions<ListInventoriesQuery, ListInventoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInventoriesQuery, ListInventoriesQueryVariables>(ListInventoriesDocument, options);
      }
export function useListInventoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInventoriesQuery, ListInventoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInventoriesQuery, ListInventoriesQueryVariables>(ListInventoriesDocument, options);
        }
export type ListInventoriesQueryHookResult = ReturnType<typeof useListInventoriesQuery>;
export type ListInventoriesLazyQueryHookResult = ReturnType<typeof useListInventoriesLazyQuery>;
export type ListInventoriesQueryResult = Apollo.QueryResult<ListInventoriesQuery, ListInventoriesQueryVariables>;
export const GetInventoryDocument = gql`
    query GetInventory($InventoryId: Int!, $MaxItemCount: Int!) {
  GetInventory(InventoryId: $InventoryId, MaxItemCount: $MaxItemCount) {
    Inventory {
      InventoryId
      InventoryState {
        InventoryStateId
        Name
      }
      BeginAt
      EndAt
    }
    Items {
      InventoryPackageId
      PackageName
      Quantity
      UnitName
      IndicatedWeight
      IndicatedLength
      IndicatedWidth
      IndicatedHeight
      FactWeight
      FactLength
      FactWidth
      FactHeight
      PackageNumber
      StorageArea
      CheckedAt
      UserName
    }
    PackageCount
  }
}
    `;

/**
 * __useGetInventoryQuery__
 *
 * To run a query within a React component, call `useGetInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInventoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInventoryQuery({
 *   variables: {
 *      InventoryId: // value for 'InventoryId'
 *      MaxItemCount: // value for 'MaxItemCount'
 *   },
 * });
 */
export function useGetInventoryQuery(baseOptions: Apollo.QueryHookOptions<GetInventoryQuery, GetInventoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInventoryQuery, GetInventoryQueryVariables>(GetInventoryDocument, options);
      }
export function useGetInventoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInventoryQuery, GetInventoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInventoryQuery, GetInventoryQueryVariables>(GetInventoryDocument, options);
        }
export type GetInventoryQueryHookResult = ReturnType<typeof useGetInventoryQuery>;
export type GetInventoryLazyQueryHookResult = ReturnType<typeof useGetInventoryLazyQuery>;
export type GetInventoryQueryResult = Apollo.QueryResult<GetInventoryQuery, GetInventoryQueryVariables>;
export const AddInventoryPackageDocument = gql`
    mutation AddInventoryPackage($AddedInventoryPackage: AddedInventoryPackage!) {
  AddInventoryPackage(AddedInventoryPackage: $AddedInventoryPackage) {
    Error
    Item {
      InventoryPackageId
      PackageName
      Quantity
      UnitName
      IndicatedWeight
      IndicatedLength
      IndicatedWidth
      IndicatedHeight
      FactWeight
      FactLength
      FactWidth
      FactHeight
      PackageNumber
      StorageArea
      CheckedAt
      UserName
    }
    PackageCount
  }
}
    `;

/**
 * __useAddInventoryPackageMutation__
 *
 * To run a mutation, you first call `useAddInventoryPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInventoryPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInventoryPackageMutation, { data, loading, error }] = useAddInventoryPackageMutation({
 *   variables: {
 *      AddedInventoryPackage: // value for 'AddedInventoryPackage'
 *   },
 * });
 */
export function useAddInventoryPackageMutation(baseOptions?: Apollo.MutationHookOptions<AddInventoryPackageMutation, AddInventoryPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInventoryPackageMutation, AddInventoryPackageMutationVariables>(AddInventoryPackageDocument, options);
      }
export type AddInventoryPackageMutationHookResult = ReturnType<typeof useAddInventoryPackageMutation>;
export type AddInventoryPackageMutationResult = Apollo.MutationResult<AddInventoryPackageMutation>;
export type AddInventoryPackageMutationOptions = Apollo.BaseMutationOptions<AddInventoryPackageMutation, AddInventoryPackageMutationVariables>;
export const InventoryExecutedDocument = gql`
    mutation InventoryExecuted($InventoryId: Int!) {
  InventoryExecuted(InventoryId: $InventoryId)
}
    `;

/**
 * __useInventoryExecutedMutation__
 *
 * To run a mutation, you first call `useInventoryExecutedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInventoryExecutedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inventoryExecutedMutation, { data, loading, error }] = useInventoryExecutedMutation({
 *   variables: {
 *      InventoryId: // value for 'InventoryId'
 *   },
 * });
 */
export function useInventoryExecutedMutation(baseOptions?: Apollo.MutationHookOptions<InventoryExecutedMutation, InventoryExecutedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InventoryExecutedMutation, InventoryExecutedMutationVariables>(InventoryExecutedDocument, options);
      }
export type InventoryExecutedMutationHookResult = ReturnType<typeof useInventoryExecutedMutation>;
export type InventoryExecutedMutationResult = Apollo.MutationResult<InventoryExecutedMutation>;
export type InventoryExecutedMutationOptions = Apollo.BaseMutationOptions<InventoryExecutedMutation, InventoryExecutedMutationVariables>;
export const GetNfcKeyDocument = gql`
    mutation GetNFCKey {
  GetNFCKey
}
    `;

/**
 * __useGetNfcKeyMutation__
 *
 * To run a mutation, you first call `useGetNfcKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetNfcKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getNfcKeyMutation, { data, loading, error }] = useGetNfcKeyMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetNfcKeyMutation(baseOptions?: Apollo.MutationHookOptions<GetNfcKeyMutation, GetNfcKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetNfcKeyMutation, GetNfcKeyMutationVariables>(GetNfcKeyDocument, options);
      }
export type GetNfcKeyMutationHookResult = ReturnType<typeof useGetNfcKeyMutation>;
export type GetNfcKeyMutationResult = Apollo.MutationResult<GetNfcKeyMutation>;
export type GetNfcKeyMutationOptions = Apollo.BaseMutationOptions<GetNfcKeyMutation, GetNfcKeyMutationVariables>;
export const SaveNfcKeyDocument = gql`
    mutation SaveNFCKey($NFCKey: String!) {
  SaveNFCKey(NFCKey: $NFCKey)
}
    `;

/**
 * __useSaveNfcKeyMutation__
 *
 * To run a mutation, you first call `useSaveNfcKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNfcKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNfcKeyMutation, { data, loading, error }] = useSaveNfcKeyMutation({
 *   variables: {
 *      NFCKey: // value for 'NFCKey'
 *   },
 * });
 */
export function useSaveNfcKeyMutation(baseOptions?: Apollo.MutationHookOptions<SaveNfcKeyMutation, SaveNfcKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveNfcKeyMutation, SaveNfcKeyMutationVariables>(SaveNfcKeyDocument, options);
      }
export type SaveNfcKeyMutationHookResult = ReturnType<typeof useSaveNfcKeyMutation>;
export type SaveNfcKeyMutationResult = Apollo.MutationResult<SaveNfcKeyMutation>;
export type SaveNfcKeyMutationOptions = Apollo.BaseMutationOptions<SaveNfcKeyMutation, SaveNfcKeyMutationVariables>;
export const ListReceiptsDocument = gql`
    query ListReceipts($ReceiptTypeId: Int, $ReceiptStateId: Int) {
  ListReceipts(ReceiptTypeId: $ReceiptTypeId, ReceiptStateId: $ReceiptStateId) {
    Items {
      ReceiptId
      Date
      ReceiptType {
        ReceiptTypeId
        Name
      }
      ReceiptState {
        ReceiptStateId
        Name
      }
      PickedAt
      Partner {
        PartnerId
        Name
      }
      TruckPlateNumber
      TrailerPlateNumber
      Ramp {
        RampId
        Name
      }
      PackageCount
      Picking
      AdHocItems
    }
  }
}
    `;

/**
 * __useListReceiptsQuery__
 *
 * To run a query within a React component, call `useListReceiptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReceiptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReceiptsQuery({
 *   variables: {
 *      ReceiptTypeId: // value for 'ReceiptTypeId'
 *      ReceiptStateId: // value for 'ReceiptStateId'
 *   },
 * });
 */
export function useListReceiptsQuery(baseOptions?: Apollo.QueryHookOptions<ListReceiptsQuery, ListReceiptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListReceiptsQuery, ListReceiptsQueryVariables>(ListReceiptsDocument, options);
      }
export function useListReceiptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListReceiptsQuery, ListReceiptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListReceiptsQuery, ListReceiptsQueryVariables>(ListReceiptsDocument, options);
        }
export type ListReceiptsQueryHookResult = ReturnType<typeof useListReceiptsQuery>;
export type ListReceiptsLazyQueryHookResult = ReturnType<typeof useListReceiptsLazyQuery>;
export type ListReceiptsQueryResult = Apollo.QueryResult<ListReceiptsQuery, ListReceiptsQueryVariables>;
export const GetReceiptDocument = gql`
    query GetReceipt($ReceiptId: Int!) {
  GetReceipt(ReceiptId: $ReceiptId) {
    Receipt {
      ReceiptId
      Date
      ReceiptType {
        ReceiptTypeId
        Name
      }
      ReceiptState {
        ReceiptStateId
        Name
      }
      Partner {
        PartnerId
        Name
      }
      TruckPlateNumber
      TrailerPlateNumber
      Ramp {
        RampId
        Name
      }
    }
    DeviationTypes {
      DeviationTypeId
      Name
      Photo
    }
    Units {
      UnitId
      Name
    }
    Items {
      Execute
      SingleLabel
      ReceiptPackageId
      ReceiptActivityId
      ExecutedAt
      OrderNumber
      PackageName
      Quantity
      QuantityUnit {
        UnitId
        Name
      }
      FactQuantity
      FactQuantityUnit {
        UnitId
        Name
      }
      IndicatedPalletSpaces
      IndicatedWeight
      IndicatedLength
      IndicatedWidth
      IndicatedHeight
      FactPalletSpaces
      FactWeight
      FactLength
      FactWidth
      FactHeight
      DestinationPartner {
        PartnerId
        Name
      }
      PackageNumber
      SecondaryPackageNumber
      StorageArea
      Deviations
      Photos
    }
    DangerousGoods {
      OrderItemDangerousGoodsId
      DangerousGoodsTypeName
      UNNumber
      Name
      Amount
      AmountTypeName
      Quantity
      PackageTypeName
      Points
      EnvironmentallyHazardous
      ADRMarkingCode1
      ADRMarkingCode2
      ADRMarkingCode3
      ReceiptPackageId
    }
    DangerousGoodsFeature
  }
}
    `;

/**
 * __useGetReceiptQuery__
 *
 * To run a query within a React component, call `useGetReceiptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiptQuery({
 *   variables: {
 *      ReceiptId: // value for 'ReceiptId'
 *   },
 * });
 */
export function useGetReceiptQuery(baseOptions: Apollo.QueryHookOptions<GetReceiptQuery, GetReceiptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceiptQuery, GetReceiptQueryVariables>(GetReceiptDocument, options);
      }
export function useGetReceiptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiptQuery, GetReceiptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceiptQuery, GetReceiptQueryVariables>(GetReceiptDocument, options);
        }
export type GetReceiptQueryHookResult = ReturnType<typeof useGetReceiptQuery>;
export type GetReceiptLazyQueryHookResult = ReturnType<typeof useGetReceiptLazyQuery>;
export type GetReceiptQueryResult = Apollo.QueryResult<GetReceiptQuery, GetReceiptQueryVariables>;
export const GetPickingReceiptDocument = gql`
    query GetPickingReceipt($ReceiptId: Int!) {
  GetReceipt(ReceiptId: $ReceiptId) {
    Receipt {
      ReceiptId
      Date
      ReceiptType {
        ReceiptTypeId
        Name
      }
      ReceiptState {
        ReceiptStateId
        Name
      }
      Partner {
        PartnerId
        Name
      }
      TruckPlateNumber
      TrailerPlateNumber
      Ramp {
        RampId
        Name
      }
    }
    Items {
      Execute
      SingleLabel
      ReceiptPackageId
      ReceiptActivityId
      PickedAt
      OrderNumber
      PackageName
      Quantity
      QuantityUnit {
        UnitId
        Name
      }
      FactQuantity
      FactQuantityUnit {
        UnitId
        Name
      }
      IndicatedPalletSpaces
      IndicatedWeight
      IndicatedLength
      IndicatedWidth
      IndicatedHeight
      FactPalletSpaces
      FactWeight
      FactLength
      FactWidth
      FactHeight
      DestinationPartner {
        PartnerId
        Name
      }
      PackageNumber
      SecondaryPackageNumber
      StorageArea
      Deviations
      Photos
    }
  }
}
    `;

/**
 * __useGetPickingReceiptQuery__
 *
 * To run a query within a React component, call `useGetPickingReceiptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPickingReceiptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPickingReceiptQuery({
 *   variables: {
 *      ReceiptId: // value for 'ReceiptId'
 *   },
 * });
 */
export function useGetPickingReceiptQuery(baseOptions: Apollo.QueryHookOptions<GetPickingReceiptQuery, GetPickingReceiptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPickingReceiptQuery, GetPickingReceiptQueryVariables>(GetPickingReceiptDocument, options);
      }
export function useGetPickingReceiptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPickingReceiptQuery, GetPickingReceiptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPickingReceiptQuery, GetPickingReceiptQueryVariables>(GetPickingReceiptDocument, options);
        }
export type GetPickingReceiptQueryHookResult = ReturnType<typeof useGetPickingReceiptQuery>;
export type GetPickingReceiptLazyQueryHookResult = ReturnType<typeof useGetPickingReceiptLazyQuery>;
export type GetPickingReceiptQueryResult = Apollo.QueryResult<GetPickingReceiptQuery, GetPickingReceiptQueryVariables>;
export const GetReleaseReceiptDocument = gql`
    query GetReleaseReceipt($ReceiptId: Int!) {
  GetReceipt(ReceiptId: $ReceiptId) {
    Receipt {
      ReceiptId
      Date
      ReceiptType {
        ReceiptTypeId
        Name
      }
      ReceiptState {
        ReceiptStateId
        Name
      }
      Partner {
        PartnerId
        Name
      }
      TruckPlateNumber
      TrailerPlateNumber
      Ramp {
        RampId
        Name
      }
      AdHocItems
    }
    Items {
      Execute
      SingleLabel
      ReceiptPackageId
      ReceiptActivityId
      ExecutedAt
      OrderNumber
      PackageName
      Quantity
      QuantityUnit {
        UnitId
        Name
      }
      FactQuantity
      FactQuantityUnit {
        UnitId
        Name
      }
      IndicatedWeight
      IndicatedLength
      IndicatedWidth
      IndicatedHeight
      FactWeight
      FactLength
      FactWidth
      FactHeight
      DestinationPartner {
        PartnerId
        Name
      }
      PackageNumber
      SecondaryPackageNumber
      StorageArea
      Deviations
      Photos
    }
  }
}
    `;

/**
 * __useGetReleaseReceiptQuery__
 *
 * To run a query within a React component, call `useGetReleaseReceiptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReleaseReceiptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReleaseReceiptQuery({
 *   variables: {
 *      ReceiptId: // value for 'ReceiptId'
 *   },
 * });
 */
export function useGetReleaseReceiptQuery(baseOptions: Apollo.QueryHookOptions<GetReleaseReceiptQuery, GetReleaseReceiptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReleaseReceiptQuery, GetReleaseReceiptQueryVariables>(GetReleaseReceiptDocument, options);
      }
export function useGetReleaseReceiptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReleaseReceiptQuery, GetReleaseReceiptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReleaseReceiptQuery, GetReleaseReceiptQueryVariables>(GetReleaseReceiptDocument, options);
        }
export type GetReleaseReceiptQueryHookResult = ReturnType<typeof useGetReleaseReceiptQuery>;
export type GetReleaseReceiptLazyQueryHookResult = ReturnType<typeof useGetReleaseReceiptLazyQuery>;
export type GetReleaseReceiptQueryResult = Apollo.QueryResult<GetReleaseReceiptQuery, GetReleaseReceiptQueryVariables>;
export const PrintLabelsDocument = gql`
    mutation PrintLabels($ReceiptId: Int!) {
  PrintLabels(ReceiptId: $ReceiptId)
}
    `;

/**
 * __usePrintLabelsMutation__
 *
 * To run a mutation, you first call `usePrintLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printLabelsMutation, { data, loading, error }] = usePrintLabelsMutation({
 *   variables: {
 *      ReceiptId: // value for 'ReceiptId'
 *   },
 * });
 */
export function usePrintLabelsMutation(baseOptions?: Apollo.MutationHookOptions<PrintLabelsMutation, PrintLabelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintLabelsMutation, PrintLabelsMutationVariables>(PrintLabelsDocument, options);
      }
export type PrintLabelsMutationHookResult = ReturnType<typeof usePrintLabelsMutation>;
export type PrintLabelsMutationResult = Apollo.MutationResult<PrintLabelsMutation>;
export type PrintLabelsMutationOptions = Apollo.BaseMutationOptions<PrintLabelsMutation, PrintLabelsMutationVariables>;
export const PrintLabelDocument = gql`
    mutation PrintLabel($ReceiptId: Int!, $ReceiptActivityId: Int!) {
  PrintLabel(ReceiptId: $ReceiptId, ReceiptActivityId: $ReceiptActivityId)
}
    `;

/**
 * __usePrintLabelMutation__
 *
 * To run a mutation, you first call `usePrintLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printLabelMutation, { data, loading, error }] = usePrintLabelMutation({
 *   variables: {
 *      ReceiptId: // value for 'ReceiptId'
 *      ReceiptActivityId: // value for 'ReceiptActivityId'
 *   },
 * });
 */
export function usePrintLabelMutation(baseOptions?: Apollo.MutationHookOptions<PrintLabelMutation, PrintLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintLabelMutation, PrintLabelMutationVariables>(PrintLabelDocument, options);
      }
export type PrintLabelMutationHookResult = ReturnType<typeof usePrintLabelMutation>;
export type PrintLabelMutationResult = Apollo.MutationResult<PrintLabelMutation>;
export type PrintLabelMutationOptions = Apollo.BaseMutationOptions<PrintLabelMutation, PrintLabelMutationVariables>;
export const RefreshReleaseReceiptDocument = gql`
    mutation RefreshReleaseReceipt($ReceiptId: Int!) {
  RefreshReleaseReceipt(ReceiptId: $ReceiptId)
}
    `;

/**
 * __useRefreshReleaseReceiptMutation__
 *
 * To run a mutation, you first call `useRefreshReleaseReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshReleaseReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshReleaseReceiptMutation, { data, loading, error }] = useRefreshReleaseReceiptMutation({
 *   variables: {
 *      ReceiptId: // value for 'ReceiptId'
 *   },
 * });
 */
export function useRefreshReleaseReceiptMutation(baseOptions?: Apollo.MutationHookOptions<RefreshReleaseReceiptMutation, RefreshReleaseReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshReleaseReceiptMutation, RefreshReleaseReceiptMutationVariables>(RefreshReleaseReceiptDocument, options);
      }
export type RefreshReleaseReceiptMutationHookResult = ReturnType<typeof useRefreshReleaseReceiptMutation>;
export type RefreshReleaseReceiptMutationResult = Apollo.MutationResult<RefreshReleaseReceiptMutation>;
export type RefreshReleaseReceiptMutationOptions = Apollo.BaseMutationOptions<RefreshReleaseReceiptMutation, RefreshReleaseReceiptMutationVariables>;
export const PackageReceivedDocument = gql`
    mutation PackageReceived($ReceivedPackage: ReceivedPackage!) {
  PackageReceived(ReceivedPackage: $ReceivedPackage) {
    ExecutedAt
    Photos
  }
}
    `;

/**
 * __usePackageReceivedMutation__
 *
 * To run a mutation, you first call `usePackageReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePackageReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [packageReceivedMutation, { data, loading, error }] = usePackageReceivedMutation({
 *   variables: {
 *      ReceivedPackage: // value for 'ReceivedPackage'
 *   },
 * });
 */
export function usePackageReceivedMutation(baseOptions?: Apollo.MutationHookOptions<PackageReceivedMutation, PackageReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PackageReceivedMutation, PackageReceivedMutationVariables>(PackageReceivedDocument, options);
      }
export type PackageReceivedMutationHookResult = ReturnType<typeof usePackageReceivedMutation>;
export type PackageReceivedMutationResult = Apollo.MutationResult<PackageReceivedMutation>;
export type PackageReceivedMutationOptions = Apollo.BaseMutationOptions<PackageReceivedMutation, PackageReceivedMutationVariables>;
export const ReceiptExecutedDocument = gql`
    mutation ReceiptExecuted($ReceiptId: Int!) {
  ReceiptExecuted(ReceiptId: $ReceiptId)
}
    `;

/**
 * __useReceiptExecutedMutation__
 *
 * To run a mutation, you first call `useReceiptExecutedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReceiptExecutedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [receiptExecutedMutation, { data, loading, error }] = useReceiptExecutedMutation({
 *   variables: {
 *      ReceiptId: // value for 'ReceiptId'
 *   },
 * });
 */
export function useReceiptExecutedMutation(baseOptions?: Apollo.MutationHookOptions<ReceiptExecutedMutation, ReceiptExecutedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReceiptExecutedMutation, ReceiptExecutedMutationVariables>(ReceiptExecutedDocument, options);
      }
export type ReceiptExecutedMutationHookResult = ReturnType<typeof useReceiptExecutedMutation>;
export type ReceiptExecutedMutationResult = Apollo.MutationResult<ReceiptExecutedMutation>;
export type ReceiptExecutedMutationOptions = Apollo.BaseMutationOptions<ReceiptExecutedMutation, ReceiptExecutedMutationVariables>;
export const PackagePickedDocument = gql`
    mutation PackagePicked($PickedPackage: PickedPackage!) {
  PackagePicked(PickedPackage: $PickedPackage) {
    PickedAt
  }
}
    `;

/**
 * __usePackagePickedMutation__
 *
 * To run a mutation, you first call `usePackagePickedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePackagePickedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [packagePickedMutation, { data, loading, error }] = usePackagePickedMutation({
 *   variables: {
 *      PickedPackage: // value for 'PickedPackage'
 *   },
 * });
 */
export function usePackagePickedMutation(baseOptions?: Apollo.MutationHookOptions<PackagePickedMutation, PackagePickedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PackagePickedMutation, PackagePickedMutationVariables>(PackagePickedDocument, options);
      }
export type PackagePickedMutationHookResult = ReturnType<typeof usePackagePickedMutation>;
export type PackagePickedMutationResult = Apollo.MutationResult<PackagePickedMutation>;
export type PackagePickedMutationOptions = Apollo.BaseMutationOptions<PackagePickedMutation, PackagePickedMutationVariables>;
export const ReceiptPickedDocument = gql`
    mutation ReceiptPicked($ReceiptId: Int!) {
  ReceiptPicked(ReceiptId: $ReceiptId)
}
    `;

/**
 * __useReceiptPickedMutation__
 *
 * To run a mutation, you first call `useReceiptPickedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReceiptPickedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [receiptPickedMutation, { data, loading, error }] = useReceiptPickedMutation({
 *   variables: {
 *      ReceiptId: // value for 'ReceiptId'
 *   },
 * });
 */
export function useReceiptPickedMutation(baseOptions?: Apollo.MutationHookOptions<ReceiptPickedMutation, ReceiptPickedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReceiptPickedMutation, ReceiptPickedMutationVariables>(ReceiptPickedDocument, options);
      }
export type ReceiptPickedMutationHookResult = ReturnType<typeof useReceiptPickedMutation>;
export type ReceiptPickedMutationResult = Apollo.MutationResult<ReceiptPickedMutation>;
export type ReceiptPickedMutationOptions = Apollo.BaseMutationOptions<ReceiptPickedMutation, ReceiptPickedMutationVariables>;
export const PackageReleasedDocument = gql`
    mutation PackageReleased($ReleasedPackage: ReleasedPackage!) {
  PackageReleased(ReleasedPackage: $ReleasedPackage) {
    ExecutedAt
  }
}
    `;

/**
 * __usePackageReleasedMutation__
 *
 * To run a mutation, you first call `usePackageReleasedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePackageReleasedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [packageReleasedMutation, { data, loading, error }] = usePackageReleasedMutation({
 *   variables: {
 *      ReleasedPackage: // value for 'ReleasedPackage'
 *   },
 * });
 */
export function usePackageReleasedMutation(baseOptions?: Apollo.MutationHookOptions<PackageReleasedMutation, PackageReleasedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PackageReleasedMutation, PackageReleasedMutationVariables>(PackageReleasedDocument, options);
      }
export type PackageReleasedMutationHookResult = ReturnType<typeof usePackageReleasedMutation>;
export type PackageReleasedMutationResult = Apollo.MutationResult<PackageReleasedMutation>;
export type PackageReleasedMutationOptions = Apollo.BaseMutationOptions<PackageReleasedMutation, PackageReleasedMutationVariables>;
export const AddReleasedPackageDocument = gql`
    mutation AddReleasedPackage($AddedReleasePackage: AddedReleasePackage!) {
  AddReleasedPackage(AddedReleasePackage: $AddedReleasePackage) {
    Error
    Item {
      Execute
      SingleLabel
      ReceiptPackageId
      ReceiptActivityId
      ExecutedAt
      OrderNumber
      PackageName
      Quantity
      QuantityUnit {
        UnitId
        Name
      }
      FactQuantity
      FactQuantityUnit {
        UnitId
        Name
      }
      IndicatedWeight
      IndicatedLength
      IndicatedWidth
      IndicatedHeight
      FactWeight
      FactLength
      FactWidth
      FactHeight
      DestinationPartner {
        PartnerId
        Name
      }
      PackageNumber
      SecondaryPackageNumber
      StorageArea
      Deviations
      Photos
    }
  }
}
    `;

/**
 * __useAddReleasedPackageMutation__
 *
 * To run a mutation, you first call `useAddReleasedPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReleasedPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReleasedPackageMutation, { data, loading, error }] = useAddReleasedPackageMutation({
 *   variables: {
 *      AddedReleasePackage: // value for 'AddedReleasePackage'
 *   },
 * });
 */
export function useAddReleasedPackageMutation(baseOptions?: Apollo.MutationHookOptions<AddReleasedPackageMutation, AddReleasedPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddReleasedPackageMutation, AddReleasedPackageMutationVariables>(AddReleasedPackageDocument, options);
      }
export type AddReleasedPackageMutationHookResult = ReturnType<typeof useAddReleasedPackageMutation>;
export type AddReleasedPackageMutationResult = Apollo.MutationResult<AddReleasedPackageMutation>;
export type AddReleasedPackageMutationOptions = Apollo.BaseMutationOptions<AddReleasedPackageMutation, AddReleasedPackageMutationVariables>;
export const GetWebPubSubClientAccessUrlDocument = gql`
    mutation GetWebPubSubClientAccessUrl {
  GetWebPubSubClientAccessUrl
}
    `;

/**
 * __useGetWebPubSubClientAccessUrlMutation__
 *
 * To run a mutation, you first call `useGetWebPubSubClientAccessUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetWebPubSubClientAccessUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getWebPubSubClientAccessUrlMutation, { data, loading, error }] = useGetWebPubSubClientAccessUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetWebPubSubClientAccessUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetWebPubSubClientAccessUrlMutation, GetWebPubSubClientAccessUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetWebPubSubClientAccessUrlMutation, GetWebPubSubClientAccessUrlMutationVariables>(GetWebPubSubClientAccessUrlDocument, options);
      }
export type GetWebPubSubClientAccessUrlMutationHookResult = ReturnType<typeof useGetWebPubSubClientAccessUrlMutation>;
export type GetWebPubSubClientAccessUrlMutationResult = Apollo.MutationResult<GetWebPubSubClientAccessUrlMutation>;
export type GetWebPubSubClientAccessUrlMutationOptions = Apollo.BaseMutationOptions<GetWebPubSubClientAccessUrlMutation, GetWebPubSubClientAccessUrlMutationVariables>;